<script>
import {
  FacebookIcon,
  InstagramIcon,
  TwitterIcon,
  LinkedinIcon,
  MailIcon,
} from "vue-feather-icons";
export default {
  data() {
    return {};
  },
  components: {
    FacebookIcon,
    InstagramIcon,
    TwitterIcon,
    LinkedinIcon,
    MailIcon,
  },
};
</script>

<template>
  <div>
    <!-- Footer Start -->
    <footer class="footer">
      <div class="container">
        <div class="row">
          <div class="col-lg-9 col-12 mb-0 mb-md-9 pb-0 pb-md-2">
            <a href="#" class="logo-footer">
              <img src="images/abebox/logo_abebox_bw.png" height="104" alt="" />
            </a>
            <p class="mt-4">
              Developed in the University of Tor Vergata in the Department of Electronic Engineering - Data Privacy Lab.
            </p>

            <!--end icon-->
          </div>
          <!--end col-->



          <div class="col-lg-3 col-md-4 col-12 mt-4 mt-sm-0 pt-2 pt-sm-0">
            <h5 class="text-light footer-head">Researchers</h5>
            <ul class="list-unstyled footer-list mt-4">
              <li>
                <span class="text-foot"
                  ><i class="mdi mdi-chevron-right mr-1"></i> Lorenzo Bracciale</span>
              </li>
              <li>
                <span class="text-foot"
                  ><i class="mdi mdi-chevron-right mr-1"></i> Pierpaolo Loreti</span>
              </li>
              <li>
                <span class="text-foot"
                  ><i class="mdi mdi-chevron-right mr-1"></i> Emanuele Raso</span>
              </li>
              <li>
                <span class="text-foot"
                  ><i class="mdi mdi-chevron-right mr-1"></i> Giuseppe Bianchi</span>
              </li>
            </ul>
          </div>
          <!--end col-->

          <!--end col-->
        </div>
        <!--end row-->
      </div>
      <!--end container-->
    </footer>
    <!--end footer-->

    <!--end footer-->
  </div>
</template>
